import React from "react";
import { Route } from "react-router-dom";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import RedirectPage from "../../pages/RedirectPage";

const ProtectedRoute = ({ component, ...args }) => {
  return (
    <Route
      component={withAuthenticationRequired(component, {
        onRedirecting: () => <RedirectPage />
      })}
      {...args}
    />
  );
};

export default ProtectedRoute;
